import { render, staticRenderFns } from "./MagypagoLinkService.vue?vue&type=template&id=0bd7b948&functional=true&"
import script from "./MagypagoLinkService.vue?vue&type=script&lang=js&"
export * from "./MagypagoLinkService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports